module.exports = __webpack_public_path__ + "img/manage_reject.25dd3c04.svg";